export default [
    {
        text : "未派遣",
        value : "pending"
    },
    {
        text : "已派遣",
        value : "success"
    }
]